<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<button
  class="general-icon-button"
  type="button"
  [style.height.px]="buttonSize()"
  [style.width.px]="buttonSize()"
  [appTooltip]="buttonTooltip() | translate"
  [position]="buttonTooltipPosition()"
  [ngClass]="buttonStyle()"
  [disabled]="disabled()"
  (click)="buttonClicked.emit($event)"
>
  <mat-icon
    class="general-button-icon"
    aria-hidden="false"
    [style.width.px]="iconSize()"
    [style.height.px]="iconSize()"
    [svgIcon]="buttonIcon() || ''"
  />
</button>
